export default "__VITE_ASSET__BqUptTSP__"